import { GetProp } from "antd/lib";
import { Prompts } from "@ant-design/x";

export const senderPromptsItems: GetProp<typeof Prompts, "items"> = [];

